import React, { useState, useRef } from 'react'
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import Updateworklog from '../../Updateworklog';
import TryoutModel from '../../../components/Modals/TryoutModel';
import Popup from './Popup';
import { AiOutlineDownload, AiOutlineClose, AiOutlineUpload } from 'react-icons/ai';
import { BsChevronRight, BsFileEarmarkTextFill, BsPlus, BsPencilSquare } from "react-icons/bs";

const InfoTable = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isUpdateWorklogOpen, setIsUpdateWorklogOpen] = useState(false);
  const [showTryoutModel, setShowTryoutModel] = useState(false);
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    console.log("Selected file:", file);
    // Add your file upload logic here
  };

  const openUpdateWorklog = () => {
    setIsUpdateWorklogOpen(true);
  }
  const closeUpdateWorklog = () => {
    setIsUpdateWorklogOpen(false);
  }

  const openTryoutModel = () => {
    setShowTryoutModel(true);
  }
  const closeTryoutModel = () => {
    setShowTryoutModel(false);
  }
  const openSendTryoutModel = () => {
    setIsPopupOpen(true);
  }
  const closeSendTryoutModel = () => {
    setIsPopupOpen(false);
  }

  return (
    <>
      <div className="p-6 my-6 border rounded-lg bg-white shadow-lg">
        <div className="flex items-center justify-between bg-gray-100 p-2 rounded-lg">
          <div className="flex items-center">
            <div className="ml-1">
              <p className="text-gray-400">Status:</p>
              <span className="px-3 py-1 bg-green-300 text-green-700 rounded-md text-sm">Inprogress</span>
              <BsPencilSquare className='mt-1 cursor-pointer' size={12} />
            </div>
          </div>
          <div className="flex items-center">
            <div className="ml-4">
              <p className="text-gray-400">Doctor:</p>
              <p className="">Test Doctor</p>
            </div>
          </div>
          <div className="flex items-center">
            <div className="ml-4">
              <p className="text-gray-400">Patient:</p>
              <p className="">Test</p>
            </div>
          </div>
          <div className="flex items-center">
            <div className="ml-4">
              <p className="text-gray-400">Date received:</p>
              <p className="">05/31/2024</p>
            </div>
          </div>
          <div className="flex items-center">
            <div className="ml-4">
              <p className="text-gray-400">Ship Date:</p>
              <p className="text-red-400">07/05/2024</p>
            </div>
          </div>
          <div className="flex items-center">
            <div className="ml-4">
              <p className="text-gray-400">Finish Date:</p>
              <p className="text-red-400">07/05/2024</p>
            </div>
          </div>
          <div className="flex items-center">
            <div className="ml-4">
              <p className="text-gray-400">Appointment:</p>
              <p className="text-gray-500">07/05/2024</p>
            </div>
          </div>
          <div className="flex items-center">
            <div className="ml-4">
              <p className="text-gray-400">Notes:</p>
              <p className="">2nd test case</p>
            </div>
          </div>
        </div>
      </div>

      {/* ---- Attachments ---- */}
      <div className="p-6 my-6 border rounded-lg bg-white shadow-lg">
        <h5 className="font-semibold text-gray-700">Attachments</h5>
        <div className="flex items-center justify-between mt-4">
          <div className="flex items-center">
            <img
              src="https://images.app.goo.gl/iRwxftfxYEVgbYgk7"
              alt="Attachment"
              className="w-12 h-12 rounded-full object-cover"
            />
            <div className="ml-4">
              <p className="text-gray-800 font-medium">dsBufferB.jpg</p>
              <p className="text-gray-500">(Waseem Qasim)</p>
              <p className="text-gray-500">07/05/2024</p>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <Button color="link" className="text-teal-500 p-0">
              <AiOutlineDownload size={24} />
            </Button>
            <Button color="link" className="text-red-500 p-0">
              <AiOutlineClose size={24} />
            </Button>
          </div>
        </div>
        <div className="flex justify-center mt-6">
          <Button
            color="primary"
            className="flex items-center bg-teal-500 text-white px-4 py-2 rounded-md border-0 hover:bg-teal-600"
            onClick={handleButtonClick}
          >
            <AiOutlineUpload size={20} className="mr-2 font-bold" />
            Upload
          </Button>
          <input
            type="file"
            ref={fileInputRef}
            className="hidden"
            accept="image/*"
            onChange={handleFileChange}
          />
        </div>
      </div>

      {/* ---- Work Log ---- */}
      <div className="p-6 my-6 border rounded-lg bg-white shadow-lg">
        <h5 className="font-semibold text-gray-700">Work Log</h5>
        <Link className="flex items-center justify-between bg-gray-100 mt-4 p-2 rounded-lg">
          <div className="flex items-center">
            <div className="ml-4">
              <p className="text-gray-800">Test</p>
              <p className="text-gray-500">07/05/2024</p>
              <p className="text-gray-500 font-bold">Waseem Qasim</p>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <Button color="link" className="text-teal-500 p-0">
              <BsChevronRight size={24} />
            </Button>
          </div>
        </Link>
        <div className="flex justify-center mt-6 gap-1">
          <Button
            onClick={openUpdateWorklog}
            color="primary"
            className="flex items-center bg-teal-500 text-white px-4 py-2 rounded-md border-0 hover:bg-teal-600"
          >
            <BsPlus size={20} className="mr-2" />
            Add To Work Log
          </Button>

          <Button
            color="primary"
            onClick={openUpdateWorklog}
            className="flex items-center bg-teal-500 text-white px-4 py-2 rounded-md border-0 hover:bg-teal-600"
          >
            <BsFileEarmarkTextFill size={20} className="mr-2" />
            Task Scheduler
          </Button>
        </div>
      </div>

      {/* ---- Tryout dates ---- */}
      <div className="p-6 my-6 border rounded-lg bg-white shadow-lg">
        <h5 className="font-semibold text-gray-700">Tryout Dates</h5>
        <div className="flex items-center justify-between bg-gray-100 mt-4 p-2 rounded-lg">
          <div className="flex items-center">
            <div className="ml-4">
              <p className="text-gray-500">Wheel Excavator 21</p>
            </div>
          </div>
          <div className="flex items-center">
            <div className="ml-4">
              <p className="text-gray-400">Ship Date:</p>
              <p className="text-red-400">07/05/2024</p>
            </div>
          </div>
          <div className="flex items-center">
            <div className="ml-4">
              <p className="text-gray-400">Appointment:</p>
              <p className="text-gray-500">07/05/2024</p>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <Button color="link" className="text-teal-500 p-0">
              <BsPencilSquare size={24} />
            </Button>
          </div>
        </div>
        <div className="flex items-center justify-between bg-gray-100 mt-4 p-2 rounded-lg">
          <div className="flex items-center">
            <div className="ml-4">
              <p className="text-gray-500">Wheel Excavator 21</p>
            </div>
          </div>
          <div className="flex items-center">
            <div className="ml-4">
              <p className="text-gray-400">Ship Date:</p>
              <p className="text-red-400">07/05/2024</p>
            </div>
          </div>
          <div className="flex items-center">
            <div className="ml-4">
              <p className="text-gray-400">Appointment:</p>
              <p className="text-gray-500">07/05/2024</p>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <Button color="link" className="text-teal-500 p-0">
              <BsPencilSquare size={24} />
            </Button>
          </div>
        </div>
        <div className="flex justify-center mt-6 gap-1">
          <Button
            color="primary"
            onClick={openTryoutModel}
            className="flex items-center bg-teal-500 text-white px-4 py-2 rounded-md border-0 hover:bg-teal-600"
          >
            <BsPlus size={20} className="mr-2" />
            Add To Tryout
          </Button>

          <Button
            color="primary"
            onClick={openSendTryoutModel}
            className="flex items-center bg-teal-500 text-white px-4 py-2 rounded-md border-0 hover:bg-teal-600"
          >
            Send to Tryout
          </Button>
        </div>
      </div>

      <Updateworklog 
        isOpen={isUpdateWorklogOpen} 
        onClose={closeUpdateWorklog} 
      />

      <TryoutModel 
        isOpen={showTryoutModel} 
        onClose={closeTryoutModel} 
      />

      <Popup
        isOpen={isPopupOpen} 
        onClose={closeSendTryoutModel} 
      />
    </>
  )
}

export default InfoTable
